import authSvc from '@efex-services/auth/authSvc';
import useImmediateApiCall from '@main-hooks/useImmediateApiCall';
import { selectProfileData } from '@pages/profile/store/selectors';
import { IMembers } from '@pages/profile/types';
import { deepSnakeToCamel } from '@utils/formater';
import { useEffect, useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const useTeamMember = () => {
  const [search, setSearch] = useState('');
  const navigate = useNavigate();
  const userProfile = useSelector(selectProfileData);

  const enterpriseId = userProfile?.company?.enterpriseId;

  const {
    data: rawData,
    loading,
    retry: getTeam,
  } = useImmediateApiCall(() =>
    authSvc
      .getTeam(enterpriseId || '')
      .then((x) => deepSnakeToCamel(x) as IMembers[])
  );

  const filterData = useCallback(
    (members: IMembers[] | undefined) => {
      if (!members) return undefined;
      if (!search.trim()) return members;

      const searchTerm = search.toLowerCase();
      return members.filter((member) => {
        const firstName = member.naturalPerson.firstName.toLowerCase();
        const lastName = member.naturalPerson.lastName.toLowerCase();
        const email = member.naturalPerson.email.toLowerCase();

        return (
          firstName.includes(searchTerm) ||
          lastName.includes(searchTerm) ||
          email.includes(searchTerm)
        );
      });
    },
    [search]
  );

  const data = useMemo(() => filterData(rawData), [filterData, rawData]);

  const navigateToAddMember = () => {
    navigate('/add-team-member');
  };

  useEffect(() => {
    getTeam();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    search,
    data,
    loading,
    setSearch,
    navigateToAddMember,
  };
};

export default useTeamMember;
